export default __webpack_public_path__ + "static/media/LHAFootballTeam8.dc7286a8.png";